import { useState, useContext, FC } from 'react';
import { useModal } from '@blueprint/ui';
import { FiltersModal } from 'search/FiltersModal';
import { MobileQuickSearchButton } from 'search/MobileQuickSearchButton';
import { SearchInitiation } from 'shared/components/SearchInitiation';
import { ModalManager } from 'shared/components/ModalManager/ModalManager';
import { SearchContext } from 'search/SearchContext';

import {
    DesktopSubHeaderWrapper,
    StyledMobileQuickSearchBar,
    LocationWrapper,
    StickyQuickSearchBarWrapper,
    StickyQuickSearchBarDynamicShadow,
    SearchInputWrapper
} from 'search/Layout/Layout.styles';
import type { ModalTypes } from 'shared/components/ModalManager/ModalManager.types';
import { LayoutVersion } from '../../constants';
import { DesktopFiltersButtonWrapper } from 'search/FiltersModal/Filters.styles';

const mobileModalUpdateResultsText = 'Update results';

type SearchAndFitersWrapperProps = {
    showFiltersOnDesktop?: boolean;
};

const SearchAndFitersWrapper: FC<SearchAndFitersWrapperProps> = ({
    children,
    showFiltersOnDesktop = false
}) => {
    const { state } = useContext(SearchContext);

    const [modalType, setModalType] = useState<ModalTypes | null>(null);
    const [isModalShowing, openModal, closeModal] = useModal();

    const openModalType = (type: ModalTypes) => {
        setModalType(type);
        openModal(null);
    };

    const closeModalType = () => {
        setModalType(null);
        closeModal();
    };

    const { searchType } = state;

    return (
        <>
            <StickyQuickSearchBarDynamicShadow data-testid="search-and-filters">
                <StickyQuickSearchBarWrapper>
                    <StyledMobileQuickSearchBar>
                        <LocationWrapper>
                            <MobileQuickSearchButton
                                openModal={openModalType}
                            />
                        </LocationWrapper>
                        <FiltersModal
                            version={LayoutVersion.Mobile}
                            testId="mobile-sub-header_filters-button"
                        />
                    </StyledMobileQuickSearchBar>
                </StickyQuickSearchBarWrapper>
            </StickyQuickSearchBarDynamicShadow>
            <DesktopSubHeaderWrapper
                data-testid="search-desktop-subheader"
                id="main-content"
            >
                <SearchInputWrapper>
                    <SearchInitiation
                        searchType={searchType}
                        eventCategory="search results"
                        searchSource="refine"
                    />
                </SearchInputWrapper>
                {showFiltersOnDesktop && (
                    <DesktopFiltersButtonWrapper>
                        <FiltersModal
                            version={LayoutVersion.Desktop}
                            testId="search-results-header_filters-button"
                        />
                    </DesktopFiltersButtonWrapper>
                )}
            </DesktopSubHeaderWrapper>
            {children}
            <ModalManager
                modalType={modalType}
                modalProps={{
                    updateResultsText: mobileModalUpdateResultsText,
                    enableSearchTypeTabs: false,
                    searchType,
                    eventCategory: 'search results',
                    searchSource: 'facets'
                }}
                isModalShowing={isModalShowing}
                closeModal={closeModalType}
            />
        </>
    );
};

export default SearchAndFitersWrapper;
